export default __webpack_public_path__ + "media/graphics/hotel-default-image-1bc394d6.svg";